export const BRAND_NAME = "KOPERA";
export const BRAND_TAGLINE = "Software for Cooperatives";
export const BRAND_LOGO =
  "https://static.prod-images.emergentagent.com/jobs/fb10fc68-70ec-4ea6-b47b-e28b29353181/images/eb0ebc0c2c415bfd1d32bef8b634c646fe2c786567e7450bcff7609e8d7a089a.jpeg";

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img
    src={BRAND_LOGO}
    alt="KOPERA"
    className={`${className} rounded-lg object-cover bg-white shadow-sm shrink-0`}
  />
);
